import 'cordova-plugin-purchase'
import config from './config'
import Alert from './helpers/alert'
import user from './user'
import messages from './messages';

let store = null

const EXCLUDED_SLUGS = new Set(['peaqa', 'peedexcel'])

function getStore() {
    if (!store && window.CdvPurchase && window.CdvPurchase.store) {
        store = window.CdvPurchase.store
    }
    return store
}

export function initIAP() {
    const storeInstance = getStore();
    if (!storeInstance) {
        Alert(messages.MSG_APP_STORE_ERROR)
        return
    }

    // build product definitions dynamically from the config
    const productDefs = config
        .get('apps')
        .filter(app => !EXCLUDED_SLUGS.has(app.slug))
        .map(app => ({
            id: `uk.co.daydreameducation.${app.slug}`,
            type: window.CdvPurchase.ProductType.CONSUMABLE,
            platform: window.CdvPurchase.Platform.APPLE_APPSTORE,
        }))

    // register products
    storeInstance.register(productDefs)

    // setup store event handlers
    storeInstance.when()
        .approved(transaction => {
            transaction.verify()
        })
        .verified(receipt => {
            // get the last transaction to verify
            const lastTransaction = receipt.sourceReceipt.transactions
                .filter(transaction => {
                    const isApproved = transaction.state === 'approved';
                    const isNotInAppPurchase = transaction.transactionId !== 'appstore.application';
                    return isApproved && isNotInAppPurchase;
                })
                .pop();

            // if there is no transaction return
            if (lastTransaction === undefined) {
                return
            }

            // if they have logged out tell them to login
            if (user.get('uid') === null) {
                Alert(messages.MSG_PURCHASE_NO_USER)
                return
            }

            // add the purchase to the users account
            user.get('purchased')
                .addPurchase(lastTransaction.transactionId)
                .then(() => {
                    receipt.finish()
                    Alert(messages.MSG_PURCHASE_SUCCESS)
                })
        })
        .unverified(() => Alert(messages.MSG_PURCHASE_UNVERIFIED));

    // initialize the store with iOS-specific options
    storeInstance.initialize([{
        platform: window.CdvPurchase.Platform.APPLE_APPSTORE,
        options: {
            needAppReceipt: true,
        },
    }]);
}

/**
 * Purchase a specific product by slug.
 */
export function purchaseAppBySlug(slug) {
    const storeInstance = getStore()
    if (!storeInstance) {
        return Promise.reject(messages.MSG_APP_STORE_ERROR)
    }

    // map excluded slugs to the canonical “pe”
    if (EXCLUDED_SLUGS.has(slug)) {
        slug = 'pe'
    }

    // get the product
    const productId = `uk.co.daydreameducation.${slug}`
    const product = storeInstance.get(productId)
    if (!product) {
        return Promise.reject(messages.MSG_NO_PRODUCT)
    }

    // get the product offer
    const offer = product.getOffer();
    if (!offer) {
        return Promise.reject(messages.MSG_NO_OFFER)
    }

    // purchase the offer
    return offer.order().then(error => {
        if (error) {
            const msg = error.code === CdvPurchase.ErrorCode.PAYMENT_CANCELLED
                ? messages.MSG_PURCHASE_CANCELLED
                : messages.MSG_PURCHASE_FAILED;

            return Promise.reject(msg);
        }
    });
}

/**
 * Price of a specific product by slug.
 */
export function getPriceBySlug(slug) {
    const storeInstance = getStore();
    if (!storeInstance) return null;

    // map excluded slugs to the canonical “pe”
    if (EXCLUDED_SLUGS.has(slug)) {
        slug = 'pe'
    }

    // get the product
    const productId = `uk.co.daydreameducation.${slug}`;
    const product = storeInstance.get(productId);
    if (!product) return null;

    // get the product offer
    const offer = product.getOffer();

    // get the offers phase
    const phase = offer.pricingPhases?.[0];
    if (!phase) return null;

    // return the formated price with currency
    return phase.price;
}
